/**
 * commandr.ts - Commandr (Command Palette) preferences module
 * 
 * CHANGE HISTORY:
 * - 251031_1540 [pending] danielbeer: Initial creation
 */

export const commandrModule = {
  id: 'ui-commandr',
  name: 'Command Palette',
  icon: '⌘',
  category: 'modules',
  order: 11,
  
  // Package metadata for info panel
  packageInfo: {
    name: '@opcentral/commandr',
    version: '0.2.0',
    displayVersion: '0.2.0',
    description: 'Universal command palette and keyboard shortcuts for OpCentral',
    status: 'implemented',
    implementationProgress: 85,
    dependencies: {
      '@opcentral/core': '*',
      '@opcentral/actr': '*',
      'react': '^18.0.0'
    },
    keywords: ['commands', 'keyboard', 'shortcuts', 'palette', 'navigation'],
    author: 'OpCentral Team',
    license: 'MIT'
  },
  
  settings: {
    enableCommandPalette: {
      type: 'boolean',
      label: 'Enable Command Palette',
      description: 'Show command palette with keyboard shortcut',
      defaultValue: true
    },
    
    paletteShortcut: {
      type: 'select',
      label: 'Palette Shortcut',
      description: 'Keyboard shortcut to open command palette',
      defaultValue: 'cmd+k',
      options: [
        { label: 'Cmd+K / Ctrl+K', value: 'cmd+k' },
        { label: 'Cmd+P / Ctrl+P', value: 'cmd+p' },
        { label: 'Cmd+Shift+P / Ctrl+Shift+P', value: 'cmd+shift+p' }
      ],
      visible: (settings) => settings['ui-commandr.enableCommandPalette']
    },
    
    showRecentCommands: {
      type: 'boolean',
      label: 'Show Recent Commands',
      description: 'Display recently used commands first',
      defaultValue: true
    },
    
    maxRecentCommands: {
      type: 'number',
      label: 'Max Recent Commands',
      description: 'Number of recent commands to remember',
      defaultValue: 10,
      min: 5,
      max: 50,
      visible: (settings) => settings['ui-commandr.showRecentCommands']
    },
    
    fuzzySearch: {
      type: 'boolean',
      label: 'Fuzzy Search',
      description: 'Use fuzzy matching for command search',
      defaultValue: true
    }
  }
};

export default commandrModule;
